var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isPC && 'app-pc',attrs:{"id":"app"}},[_c('TUICallKit',{staticClass:"callkit-container",staticStyle:{"z-index":"9999"},attrs:{"videoDisplayMode":_vm.VideoDisplayMode.CONTAIN,"allowedMinimized":true,"allowedFullScreen":true}}),_c('router-view'),_c('Upgrade')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }